<script setup lang="ts">
import { computed, type HTMLAttributes } from 'vue';
import {
  DialogPortal,
  DialogOverlay,
  DialogContent,
  DialogClose,
  useForwardPropsEmits,
  type DialogContentProps,
  type DialogContentEmits,
} from 'reka-ui';
import { X } from '@lucide/vue';
import { cn } from '@/lib/utils';
const props = withDefaults(
  defineProps<
    DialogContentProps & {
      class?: HTMLAttributes['class'];
      side?: 'left' | 'right';
      showClose?: boolean;
    }
  >(),
  { side: 'right', showClose: true }
);
const emit = defineEmits<DialogContentEmits>();
const forwarded = useForwardPropsEmits(
  computed(() => {
    const { class: _class, side: _side, showClose: _showClose, ...rest } = props;
    return rest;
  }),
  emit
);
</script>

<template>
  <DialogPortal>
    <DialogOverlay
      class="fixed inset-0 z-50 bg-slate-950/35 backdrop-blur-[1px] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0"
    />
    <DialogContent
      v-bind="forwarded"
      :class="
        cn(
          'fixed inset-y-0 z-50 flex h-dvh w-full max-w-lg flex-col gap-5 overflow-y-auto border bg-card p-6 shadow-[0_12px_48px_rgba(15,23,42,0.16)] duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out',
          side === 'right'
            ? 'right-0 border-l data-[state=open]:slide-in-from-right data-[state=closed]:slide-out-to-right'
            : 'left-0 border-r data-[state=open]:slide-in-from-left data-[state=closed]:slide-out-to-left',
          props.class
        )
      "
    >
      <slot />
      <DialogClose
        v-if="showClose"
        class="absolute right-4 top-4 rounded-sm p-1 text-muted-foreground opacity-75 transition-opacity hover:opacity-100 focus-visible:ring-2 focus-visible:ring-ring/30"
        aria-label="Закрыть"
        ><X class="size-4"
      /></DialogClose>
    </DialogContent>
  </DialogPortal>
</template>
